import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const HourglassFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function HourglassFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M15.4 12c2.49-1.38 4.6-3.23 4.6-6.5C20 3.02 17.98 1 15.5 1h-7C6.02 1 4 3.02 4 5.5c0 3.27 2.11 5.12 4.6 6.5C6.11 13.38 4 15.23 4 18.5 4 20.98 6.02 23 8.5 23h7c2.48 0 4.5-2.02 4.5-4.5 0-3.27-2.11-5.12-4.6-6.5Zm.1-8c.83 0 1.5.67 1.5 1.5 0 1.01-.41 1.8-1.13 2.5H8.12c-.72-.7-1.13-1.49-1.13-2.5 0-.83.67-1.5 1.5-1.5h7.01Zm0 16h-7c-.83 0-1.5-.67-1.5-1.5 0-2.22 1.87-3.38 5-4.85 3.13 1.47 5 2.62 5 4.85 0 .83-.67 1.5-1.5 1.5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default HourglassFilled;